import type { TAggregatedStatisticKey } from './types';

export const STATISTICS: { key: TAggregatedStatisticKey; title: string }[] = [
  { key: 'timeUntilArrival', title: 'Time until arrival' },
  { key: 'transitArrivalTime', title: 'Transit arrival time' },
  { key: 'timeUntilDelivery', title: 'Time until delivery' },
  { key: 'transitDeliveryTime', title: 'Transit delivery time' },
];
